import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function ComicGrid() {
  const featuredComics = comics.filter((c) => c.featured);
  const newComics = comics.filter((c) => c.isNew);
  const hotComics = comics.filter((c) => c.isHot && !c.featured);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-sm text-foreground-500 font-medium tracking-wide">精选推荐</p>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mt-2">
            本周必看推荐
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5" data-product-shop="">
          {featuredComics.map((comic) => (
            <ComicCard
              key={comic.id}
              slug={comic.slug}
              title={comic.title}
              cover={comic.cover}
              status={comic.status}
              rating={comic.rating}
              chapters={comic.chapters}
              tags={comic.tags}
              isNew={comic.isNew}
              isHot={comic.isHot}
            />
          ))}
        </div>
      </div>

      <div className="px-4 md:px-6 max-w-7xl mx-auto mt-16 md:mt-24">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <p className="text-sm text-foreground-500 font-medium tracking-wide">最新上架</p>
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mt-2">
              新作抢先看
            </h2>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5" data-product-shop="">
          {newComics.map((comic) => (
            <ComicCard
              key={comic.id}
              slug={comic.slug}
              title={comic.title}
              cover={comic.cover}
              status={comic.status}
              rating={comic.rating}
              chapters={comic.chapters}
              tags={comic.tags}
              isNew={comic.isNew}
              isHot={comic.isHot}
              updatedAt={comic.updatedAt}
            />
          ))}
          {hotComics.slice(0, 3).map((comic) => (
            <ComicCard
              key={comic.id}
              slug={comic.slug}
              title={comic.title}
              cover={comic.cover}
              status={comic.status}
              rating={comic.rating}
              chapters={comic.chapters}
              tags={comic.tags}
              isNew={comic.isNew}
              isHot={comic.isHot}
              updatedAt={comic.updatedAt}
            />
          ))}
        </div>
      </div>
    </section>
  );
}